import script from "./OCapacidadeValor.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCapacidadeValor.vue?vue&type=script&lang=ts&setup=true"

import "./OCapacidadeValor.vue?vue&type=style&index=0&id=41603290&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41603290"]])

export default __exports__